// Copyright 2025 Sorama B.V.
export class HardwareSampleRate {
    // The sample rate of the mems microphone divided by the decimation factor for Sorama CAMs (CAM64 and CAM1K)
    public static readonly defaultCAMSampleRate: number = 1500000 / 32;
}
